/*
 * Image URLs that failed to load in this browser session (a catalog picture whose file is gone at the source, a
 * link that expired). Shared by the Assets grid and the asset pickers: the grid shows a "can't be loaded" tile
 * so the asset can be trashed or replaced, and the pickers leave these out because a picture that can't be
 * downloaded can't be used in a clip or a sequence either.
 */
const broken = new Set();
const listeners = new Set();
export const isBroken = url => !!url && broken.has(url);
export function markBroken(url) {
  if (!url || broken.has(url)) return;
  broken.add(url);
  listeners.forEach(fn => {
    try {
      fn(url);
    } catch (e) {/* listener gone */}
  });
}

/** Subscribe to new failures; returns the unsubscribe function. */
export function onBroken(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}